import { getPageData } from '@/utils/getPageData';
import { useGetCrItemsSuspenseInfinite } from 'ap-openapi';
import { useEffect, useMemo } from 'react';

export const useGetCrItemsAllSuspense = () => {
  const { data, error, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetCrItemsSuspenseInfinite(
      {
        per: 1000,
      },
      {
        query: {
          getNextPageParam: (page) => {
            const url = new URL(page.data.next ?? '/', location.href);
            if (!url.searchParams.has('page')) return undefined;
            return Number(url.searchParams.get('page'));
          },
        },
      }
    );
  if (error) throw error;
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);
  return useMemo(() => getPageData(data, 'cr_items'), [data]);
};
